import template from './template.html'

function ContabilidadPolizasexternasProvisionnominasconpagossucursalesComponent (ContabilidadPolizasexternasCatalogosProyectos, ContabilidadPolizasexternasCatalogosProyectosNominas, $location, $moment) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.traerNominas = traerNominas
  $ctrl.buscar = buscar

  function $onInit () {
    $ctrl.promise = ContabilidadPolizasexternasCatalogosProyectos.get().then(function (resolve) {
      $ctrl.empresas = resolve.data
      $ctrl.nominas = undefined
      $ctrl.opciones = {
        fecha_inicio: $ctrl.busqueda.fechaInicio || $moment(new Date()).subtract(1, 'months').toDate(),
        fecha_fin: $ctrl.busqueda.fechaFin || new Date(),
        ids_empresas: $ctrl.busqueda.idsEmpresas || undefined,
        ids_nominas: $ctrl.busqueda.idsNominas || undefined,
      }
    })

  }

  function traerNominas () {
    if ($ctrl.opciones.fecha_inicio && $ctrl.opciones.fecha_fin && $ctrl.opciones.ids_empresas) {
      return ContabilidadPolizasexternasCatalogosProyectosNominas.get($ctrl.opciones.ids_empresas, $moment($ctrl.opciones.fecha_inicio).format('YYYY-MM-DD'), $moment($ctrl.opciones.fecha_fin).format('YYYY-MM-DD'))
        .then(function (resolve) {
          $ctrl.nominas = resolve.data
          $ctrl.form.$setPristine()
        })
    }
  }

  function buscar () {
    $location.search({
      fechaInicio: $moment($ctrl.opciones.fecha_inicio).format('YYYY-MM-DD'),
      fechaFin: $moment($ctrl.opciones.fecha_fin).format('YYYY-MM-DD'),
      idsEmpresas: $ctrl.opciones.ids_empresas,
      idsNominas: $ctrl.opciones.ids_nominas,
    })
  }
}

angular.module('contabilidad.polizas')
  .component('contabilidadPolizasexternasProvisionnominasconpagossucursales', {
    controller: ContabilidadPolizasexternasProvisionnominasconpagossucursalesComponent,
    template,
    bindings: {
      busqueda: '<',
    },
  })



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/provisionnominasconpagossucursales/component.js